import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axios from "axios";
import Messages from "../../config/Message";
import {
  setIsRefreshingToken,
  setIsUnauthorise,
  setIsRestricted,
} from "./authSlice";

let failedQueue = [];

export const clearFailedQueue = () => {
  failedQueue = [];
};

export const processFailedApiQueue = async (token = null) => {
  const retryPromises = failedQueue.map((req) => {
    req.headers["Authorization"] = `Bearer ${token}`; // Set the new token
    return axios(req);
  });
  await Promise.all(retryPromises);
  failedQueue = [];
};

// Slice
const interceptorSlice = createSlice({
  name: "api",
  initialState: {},
  reducers: {},
});

export default interceptorSlice.reducer;

// const trimData = (data) => {
//   if (typeof data === "string") return data.trim();

//   if (Array.isArray(data)) {
//     return data.map(trimData);
//   }

//   if (typeof data === "object" && data !== null) {
//     const newObj = {};
//     for (let key in data) {
//       newObj[key] = trimData(data[key]);
//     }
//     return newObj;
//   }

//   return data;
// };

export const setAxiosInterceptor = (dispatch, getState) => {
  axios.interceptors.request.use(
    async (config) => {
      let header = config.headers;
      const customAccept = config.headers?.Accept;
      header = {
        ...header,
        Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      const authToken = localStorage.getItem("token");
      header = authToken
        ? {
            ...header,
            Accept: customAccept || "application/json",
            Authorization: "Bearer " + authToken,
          }
        : {
            ...header,
            Accept: customAccept || "application/json",
          };
      config.headers = header;
      // if (config.data) {
      //   config.data = trimData(config.data);
      // }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  axios.interceptors.response.use(
    (response) => {
      if (response?.data?.notify) {
        message.success(response.data.notify);
      }
      return response;
    },
    (error) => {
      if (error.response) {
        const originalRequest = error.config;
        const status = error.response.status;
        const skipError = originalRequest?.skipInterceptorError;

        let { isRefreshing, token } = getState().auth;

        if (status === 401) {
          if (token) {
            failedQueue.push(originalRequest);
            if (!isRefreshing) {
              dispatch(setIsRefreshingToken(true));
              dispatch(setIsUnauthorise(true));
              isRefreshing = true;
            }
          } else {
            message.error(error.response?.data?.title);
          }
        } else if (!skipError) {
          if (status === 500) {
            message.error(Messages().global.internalServer);
          } else if (status === 403) {
            dispatch(setIsRestricted(true));
          } else if (status === 404) {
            message.error(Messages().global.notFound);
          }
        }

        return Promise.reject(error.response);
      } else {
        message.error(Messages().global.networkIssue);
      }
    },
  );
};
